import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex flex-row w-full"
};
const _hoisted_2 = {
  key: 0
};
export default {
  __name: 'StatusColorBar',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    function getColorClasses(status) {
      if (status === "Mixed") {
        return 'bg-gray-100 text-gray-400';
      } else if (status === 'Bounced') {
        return 'bg-[rgba(var(--v-theme-error),0.08)] text-error';
      } else if (status === 'Delivered') {
        return 'bg-yellow-100 text-yellow-600';
      } else if (status === 'Opened') {
        return 'bg-blue-100 text-blue-600';
      } else if (status === 'Clicked') {
        return 'bg-green-100 text-green-600';
      } else {
        return 'bg-green-50 text-gray-600';
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass([getColorClasses(__props.status), "uppercase text-xs rounded-md px-1 py-1 my-1"])
      }, [__props.status === 'Paid' ? (_openBlock(), _createElementBlock("span", _hoisted_2, [...(_cache[0] || (_cache[0] = [_createElementVNode("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("path", {
        d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM6.4 12L2.4 8L3.528 6.872L6.4 9.736L12.472 3.664L13.6 4.8L6.4 12Z",
        class: "fill-[rgb(var(--v-theme-success))]"
      })], -1)]))])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.status), 1)], 2)]);
    };
  }
};